import { UserOrg } from '../../org';

export type AllowableOrg = {
  id: string;
  name: string;
  logo?: string;
  memberCount?: number;
};

export function toAllowableOrg(userOrg: UserOrg): AllowableOrg {
  return {
    id: userOrg._id.id,
    name: userOrg.name,
    logo: userOrg.logo,
    memberCount: userOrg.memberRoles.length,
  };
}
